import React from 'react';

type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  /**
   * Screen-reader label. English by default because this package deliberately has no i18n
   * dependency — see the note on `CookieBannerProps.labels`. An app with a translator passes one:
   * `<Spinner label={t('common.loading', 'Loading')} />`.
   */
  label?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '', label = 'Loading' }) => (
  <svg
    className={['animate-spin text-brand-ink', sizeClasses[size], className].join(' ')}
    viewBox="0 0 24 24"
    fill="none"
    aria-label={label}
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
  </svg>
);
